import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetAllEmailTemplatesRPC } from "./getAllEmailTemplatesRPC";

export class GetAllEmailTemplatesRPCClientImpl extends GetAllEmailTemplatesRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetAllEmailTemplatesRPC.Request): Promise<LeoRPCResult<GetAllEmailTemplatesRPC.Response, GetAllEmailTemplatesRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/GetAllEmailTemplates",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetAllEmailTemplatesRPC.ResponseDTO,
      GetAllEmailTemplatesRPC.Errors.ErrorsDTO,
      GetAllEmailTemplatesRPC.Response,
      GetAllEmailTemplatesRPC.Errors.Errors
    >(
      response,
      "email-cycle/GetAllEmailTemplates",
      GetAllEmailTemplatesRPC.Response.fromDTO,
      GetAllEmailTemplatesRPC.Errors.fromDTO
    );
  }
}
